"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classes_1 = __importDefault(require("@nerdwallet/base-styles/classes"));
var Box_1 = require("@nerdwallet/currency/components/Box");
var AccentStar = function (_a) {
    var children = _a.children, _b = _a.size, size = _b === void 0 ? 44 : _b;
    return (react_1.default.createElement(Box_1.Box, { alignItems: "center", className: (0, classes_1.default)("color-green-darkest"), display: { desktop: "inline-flex", mobile: "flex" }, justifyContent: "center", marginRight: 3, position: "relative" },
        react_1.default.createElement("img", { alt: "green star burst", src: "https://www.nerdwallet.com/cdn/nerdwallet-plus/background-reward-star.svg", width: size, height: size }),
        react_1.default.createElement(Box_1.Box, { position: "absolute" }, children)));
};
exports.default = AccentStar;
